import Vue from 'vue'

import IconButton from './IconButton.vue'
import DateRangePicker from './DateRangePicker.vue'

Vue.component('IconButton', IconButton)
Vue.component('DateRangePicker', DateRangePicker)
